import React, { PureComponent } from 'react'

const LEDGER_GUIDE_STATIC_HREF = '/static/guides/DEX-Ledger-Documentation.html'

class LedgerGuidePage extends PureComponent {
  componentDidMount() {
    // redirect to the new static page location
    window.location.href = LEDGER_GUIDE_STATIC_HREF
  }

  render() {
    return <p>Please wait, loading Ledger guide.</p>
  }
}

export default LedgerGuidePage
